// Eyefire Case Studies — local mock data.
// API integration will replace this module later.

export const CASE_STUDIES = [
  {
    slug: 'ai-crane-safety-steel',
    industry: 'Sản xuất thép',
    tag: 'Featured',
    title: 'Giám sát an toàn cẩu trục bằng AI cho nhà máy sản xuất thép',
    excerpt:
      'EyeFire AI giúp khách hàng giám sát vùng cấm dưới cẩu trục, cảnh báo người ra vào khu vực nguy hiểm và nâng cao trực quan an toàn ở khu vực sản xuất rủi ro cao.',
    image:
      'https://images.unsplash.com/photo-1565008576549-57569a49371d?w=1200&q=80&auto=format&fit=crop',
    location: 'KCN Thăng Long, Hà Nội',
    customer: 'Hanoi Steel Center',
    system: 'AI Camera + Cảnh báo + Điều khiển cẩu trục',
    duration: '6 tháng triển khai',
    cameras: '32 camera IP',
    featured: true,
    metrics: [
      { v: '−78%', k: 'Số sự cố cảnh báo' },
      { v: '24/7', k: 'Giám sát liên tục' },
      { v: '<300ms', k: 'Độ trễ cảnh báo' },
    ],
    detail: {
      overview: {
        sub:
          'Một nhà máy sản xuất thép quy mô lớn cần một lớp an toàn AI để bảo vệ công nhân khỏi vùng vận hành của cẩu trục — nơi mọi lỗi nhỏ đều có thể dẫn đến tai nạn nghiêm trọng.',
        highlights: [
          { t: 'Vùng cấm động (Dynamic restricted zone)', d: 'Khoanh vùng nguy hiểm bám theo vị trí cẩu trục theo thời gian thực.' },
          { t: 'Phát hiện người không PPE', d: 'Nhận diện công nhân thiếu mũ bảo hộ, áo phản quang trong vùng vận hành.' },
          { t: 'Cảnh báo tức thì', d: 'Phát loa cảnh báo tại chỗ và đẩy thông báo về phòng điều hành dưới 300ms.' },
        ],
        media:
          'https://images.unsplash.com/photo-1565008576549-57569a49371d?w=1400&q=80&auto=format&fit=crop',
        mediaCap: 'Camera giám sát khu vực sản xuất',
      },
      challenge: {
        media:
          'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1200&q=80&auto=format&fit=crop',
        body: [
          'Trong môi trường sản xuất thép, cẩu trục di chuyển vật nặng hàng chục tấn qua các khu vực có nhiều công nhân vận hành. Việc người không phận sự đi vào vùng dưới cẩu hoặc đứng trong tầm di chuyển của hàng nâng là rủi ro thường trực.',
          'Trước khi triển khai EyeFire AI, khách hàng phải dựa hoàn toàn vào nhân viên an toàn quan sát qua màn hình CCTV — phương pháp này không phát hiện được mọi sự cố và phụ thuộc lớn vào sự tỉnh táo của người trực.',
        ],
        bullets: [
          'Không có cơ chế cảnh báo tự động khi người vào vùng nguy hiểm',
          'CCTV truyền thống chỉ ghi hình, không phân tích',
          'Khó truy vết sự cố do thiếu log chi tiết về hành vi và thời gian',
          'Nhân viên an toàn quá tải khi giám sát đồng thời 30+ camera',
        ],
      },
      solution: {
        intro:
          'EyeFire AI triển khai hệ thống thị giác máy tính chạy edge tại nhà máy, gồm 4 mô-đun phối hợp: phát hiện người, phát hiện cẩu trục, khoanh vùng động và phân tích hành vi. Toàn bộ dữ liệu xử lý tại chỗ, không phụ thuộc internet.',
      },
      howItWorks: [
        { icn: 'camera', t: 'Thu nhận tín hiệu', d: 'Kết nối với camera IP sẵn có tại nhà máy, không cần thay thiết bị.' },
        { icn: 'cpu', t: 'Xử lý edge AI', d: 'EyeFire Edge Box phân tích trực tiếp tại nhà máy, không phụ thuộc đám mây.' },
        { icn: 'alert', t: 'Cảnh báo tức thì', d: 'Loa cảnh báo + thông báo Telegram/Zalo trong dưới 300ms.' },
        { icn: 'chart', t: 'Báo cáo & truy vết', d: 'Dashboard tổng hợp sự kiện theo ca, ngày, người vi phạm.' },
      ],
      benefits: [
        { v: '78', unit: '%', label: 'Giảm sự cố an toàn', desc: 'So sánh 6 tháng trước và sau triển khai.' },
        { v: '50', unit: '%', label: 'Giảm cảnh báo nhiễu', desc: 'Nhờ phân loại vai trò công nhân.' },
        { v: '24', unit: '/7', label: 'Giám sát liên tục', desc: 'Không phụ thuộc vào nhân viên trực.' },
        { v: '100', unit: '%', label: 'Truy vết sự cố', desc: 'Log đầy đủ phục vụ điều tra.' },
      ],
      real: {
        images: [
          'https://images.unsplash.com/photo-1565008576549-57569a49371d?w=1200&q=80&auto=format&fit=crop',
          'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=800&q=80&auto=format&fit=crop',
          'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=800&q=80&auto=format&fit=crop',
          'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=80&auto=format&fit=crop',
          'https://images.unsplash.com/photo-1581092334651-ddf26d9a09d0?w=800&q=80&auto=format&fit=crop',
        ],
        captions: [
          'Tổng quan nhà máy',
          'Cẩu trục đang vận hành',
          'Khu vực sản xuất',
          'Khu lò luyện',
          'Khu kiểm tra chất lượng',
        ],
      },
    },
  },
  {
    slug: 'forklift-safety-warehouse',
    industry: 'Logistics & Kho vận',
    tag: 'Logistics',
    title: 'Giám sát an toàn xe nâng tại kho logistics quy mô lớn',
    excerpt:
      'Triển khai EyeFire AI để phát hiện va chạm tiềm năng giữa xe nâng và người đi bộ trong kho hàng 24/7.',
    image:
      'https://images.unsplash.com/photo-1553413077-190dd305871c?w=1200&q=80&auto=format&fit=crop',
    location: 'KCN Long Hậu, Long An',
    customer: 'Long An Logistics JSC',
    duration: '4 tháng triển khai',
    cameras: '48 camera IP',
    metrics: [
      { v: '−65%', k: 'Tình huống va chạm' },
      { v: '48', k: 'Camera triển khai' },
    ],
  },
  {
    slug: 'ppe-compliance-packaging',
    industry: 'Sản xuất bao bì',
    tag: 'PPE',
    title: 'Giám sát tuân thủ PPE cho nhà máy sản xuất bao bì',
    excerpt:
      'Nhận diện công nhân không đeo mũ bảo hộ, áo phản quang trong khu vực sản xuất — cảnh báo tức thì cho quản đốc ca.',
    image:
      'https://images.unsplash.com/photo-1581092334651-ddf26d9a09d0?w=1200&q=80&auto=format&fit=crop',
    location: 'Bình Dương',
    customer: 'Binh Duong Packaging Co.',
    duration: '3 tháng triển khai',
    cameras: '18 camera IP',
    metrics: [
      { v: '95%', k: 'Tỉ lệ tuân thủ PPE' },
      { v: '18', k: 'Camera triển khai' },
    ],
  },
  {
    slug: 'intrusion-port-terminal',
    industry: 'Cảng & Logistics',
    tag: 'Intrusion',
    title: 'AI phát hiện xâm nhập trái phép tại cảng container',
    excerpt:
      'Bảo vệ chu vi cảng container 24/7 với phát hiện chuyển động thông minh, phân biệt người/động vật/xe.',
    image:
      'https://images.unsplash.com/photo-1605883705077-8d3d3cebe78c?w=1200&q=80&auto=format&fit=crop',
    location: 'Cảng Cái Mép, BR-VT',
    customer: 'Cai Mep Container Terminal',
    duration: '5 tháng triển khai',
    cameras: '24 camera IP',
    metrics: [
      { v: '0', k: 'Sự cố xâm nhập' },
      { v: '24', k: 'Camera chu vi' },
    ],
  },
  {
    slug: 'face-attendance-corporate',
    industry: 'Văn phòng doanh nghiệp',
    tag: 'Face ID',
    title: 'Chấm công nhận diện khuôn mặt cho tập đoàn 3.000 nhân viên',
    excerpt:
      'Thay thế hoàn toàn thẻ từ và vân tay bằng nhận diện khuôn mặt — chính xác, hợp vệ sinh, không tiếp xúc.',
    image:
      'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80&auto=format&fit=crop',
    location: 'Hà Nội, 3 toà nhà',
    customer: 'Tập đoàn 3.000 nhân viên',
    duration: '2 tháng triển khai',
    cameras: '36 cổng nhận diện',
    metrics: [
      { v: '<1s', k: 'Tốc độ chấm công' },
      { v: '99.7%', k: 'Độ chính xác' },
    ],
  },
  {
    slug: 'hazardous-area-chemical',
    industry: 'Hoá chất',
    tag: 'Hazardous',
    title: 'Giám sát khu vực nguy hiểm trong nhà máy hoá chất',
    excerpt:
      'Phát hiện người vào khu vực có khí độc, vùng nóng và vùng có dung môi — tích hợp với hệ thống ngắt khẩn cấp.',
    image:
      'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=1200&q=80&auto=format&fit=crop',
    location: 'Đồng Nai',
    customer: 'Dong Nai Chemical JSC',
    duration: '7 tháng triển khai',
    cameras: '40 camera + 12 IR',
    metrics: [
      { v: '< 200ms', k: 'Ngắt khẩn cấp' },
      { v: '−82%', k: 'Cảnh báo nhiễu' },
    ],
  },
  {
    slug: 'workplace-safety-automotive',
    industry: 'Sản xuất ô tô',
    tag: 'Workplace',
    title: 'Giám sát an toàn lao động trong nhà máy lắp ráp ô tô',
    excerpt:
      'EyeFire giám sát line lắp ráp 24/7 — phát hiện thao tác sai quy trình, không đúng PPE và tình huống nguy hiểm.',
    image:
      'https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=1200&q=80&auto=format&fit=crop',
    location: 'Hải Dương',
    customer: 'Hai Duong Auto Assembly',
    duration: '8 tháng triển khai',
    cameras: '64 camera IP',
    metrics: [
      { v: '−71%', k: 'Vi phạm quy trình' },
      { v: '64', k: 'Camera triển khai' },
    ],
  },
  {
    slug: 'site-safety-construction',
    industry: 'Xây dựng',
    tag: 'Construction',
    title: 'Giám sát an toàn công trường xây dựng cao tầng',
    excerpt:
      'Phát hiện vi phạm độ cao, thiếu dây an toàn, vùng nguy hiểm dưới cẩu tháp cho công ty xây dựng lớn.',
    image:
      'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200&q=80&auto=format&fit=crop',
    location: 'TP. Hồ Chí Minh',
    customer: 'Saigon Highrise Construction',
    duration: '6 tháng triển khai',
    cameras: '28 camera IP',
    metrics: [
      { v: '−69%', k: 'Vi phạm an toàn' },
      { v: '28', k: 'Camera triển khai' },
    ],
  },
  {
    slug: 'smart-parking-mall',
    industry: 'Trung tâm thương mại',
    tag: 'Parking',
    title: 'Bãi xe thông minh cho trung tâm thương mại 1.200 chỗ',
    excerpt:
      'Nhận diện biển số, đếm chỗ trống thời gian thực, dẫn lối tự động — không cần thẻ gửi xe.',
    image:
      'https://images.unsplash.com/photo-1506521781263-d8422e82f27a?w=1200&q=80&auto=format&fit=crop',
    location: 'TP. Hồ Chí Minh',
    customer: 'Saigon Mall',
    duration: '3 tháng triển khai',
    cameras: '22 camera ANPR',
    metrics: [
      { v: '99.4%', k: 'Độ chính xác biển số' },
      { v: '<2s', k: 'Thời gian ra/vào' },
    ],
  },
];

// Build a sensible placeholder detail for cases that don't have one yet.
export function buildDetail(c) {
  if (c.detail) return c.detail;
  return {
    overview: {
      sub: c.excerpt,
      highlights: [
        { t: 'Phát hiện thông minh', d: 'Sử dụng mô hình AI thị giác để nhận diện sự kiện an toàn theo thời gian thực.' },
        { t: 'Cảnh báo tức thì', d: 'Loa cảnh báo tại chỗ kết hợp thông báo về phòng điều hành.' },
        { t: 'Báo cáo & truy vết', d: 'Tổng hợp sự kiện theo ca, người, khu vực — phục vụ điều tra và đào tạo.' },
      ],
      media: c.image,
    },
    challenge: {
      media: c.image,
      body: [
        'Khách hàng vận hành cơ sở với rủi ro an toàn cao và phụ thuộc lớn vào nhân viên giám sát. CCTV truyền thống chỉ ghi hình, không phân tích — khiến việc phát hiện sự cố luôn bị động.',
        'EyeFire AI được lựa chọn nhờ khả năng xử lý edge, tích hợp với camera sẵn có và độ chính xác đã kiểm chứng tại các nhà máy tương tự.',
      ],
      bullets: [
        'Không có cảnh báo tự động khi vi phạm',
        'Nhân viên an toàn quá tải khi giám sát thủ công',
        'Khó truy vết sự cố do thiếu log chi tiết',
        'Phụ thuộc lớn vào sự tỉnh táo của người trực',
      ],
    },
    solution: {
      intro:
        'EyeFire AI triển khai hệ thống thị giác máy tính chạy edge tại cơ sở khách hàng, gồm các mô-đun phối hợp để phát hiện sự kiện và cảnh báo theo thời gian thực.',
    },
    howItWorks: [
      { icn: 'camera', t: 'Thu nhận tín hiệu', d: 'Kết nối với camera IP sẵn có.' },
      { icn: 'cpu', t: 'Xử lý edge AI', d: 'Phân tích trực tiếp tại cơ sở.' },
      { icn: 'alert', t: 'Cảnh báo tức thì', d: 'Loa + thông báo trong <300ms.' },
      { icn: 'chart', t: 'Báo cáo & truy vết', d: 'Dashboard sự kiện theo ca.' },
    ],
    benefits: [
      { v: '70', unit: '%', label: 'Giảm vi phạm an toàn', desc: 'So với trước triển khai.' },
      { v: '50', unit: '%', label: 'Giảm cảnh báo nhiễu', desc: 'Nhờ phân loại thông minh.' },
      { v: '24', unit: '/7', label: 'Giám sát liên tục', desc: 'Không phụ thuộc nhân viên trực.' },
      { v: '100', unit: '%', label: 'Truy vết sự cố', desc: 'Log đầy đủ.' },
    ],
    real: {
      images: [c.image, c.image, c.image, c.image, c.image],
      captions: ['Tổng quan cơ sở', 'Khu vực giám sát', 'Phát hiện sự kiện', 'Dashboard điều hành', 'Báo cáo tuần'],
    },
  };
}

export function findCaseBySlug(slug) {
  return CASE_STUDIES.find((c) => c.slug === slug);
}
